export default function getIcon(fileName: string) {
  return `/icons/${fileName}.svg`;
}
